import type { IAppStores } from "../shared-components/AppMaster";
import type { IGenericIndexViewModel } from "../network/contracts/IGenericIndexViewModel";
import { AppLegal, type IAppLegal, type ILegalStores } from "./AppLegal";

export interface IAppLegalFactory {
    createMaster(viewModel: IGenericIndexViewModel, appStores: IAppStores): Promise<IAppLegal>;
}

export class AppLegalFactory implements IAppLegalFactory {
    public async createMaster(viewModel: IGenericIndexViewModel, appStores: IAppStores): Promise<IAppLegal> {
        /* stores */
        const legalStores: ILegalStores = {
            ...appStores,
        };

        return new AppLegal(legalStores);
    }
}
